var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "banner-wrapper"
  }, [_c('client-only', [_vm.hasToggleShop ? _c('BannerSeller') : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "banner d-none d-lg-flex container-fluid justify-content-between align-items-center"
  }, [_vm.isMarketOpen ? _c('SearchItem', {
    staticClass: "block-searchform col-4 bloc-02 m-0 p-0",
    attrs: {
      "data-el": "header__search"
    }
  }) : _c('div', {
    staticClass: "block-searchform col-4 bloc-02 m-0 p-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-2 offset-1"
  }, [_c('a', {
    staticClass: "d-inline-block",
    attrs: {
      "href": _vm.homeUrl
    },
    on: {
      "click": function click($event) {
        return _vm.tracking($event, {
          event_action: 'Logo',
          event_label: 'HomePage'
        });
      }
    }
  }, [_c('svg', {
    staticClass: "logo-icon fill-white",
    attrs: {
      "version": "1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 595.3 245.5",
      "height": "50",
      "width": "116",
      "role": "img",
      "aria-label": _vm.$t('home')
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M38.7 143.5h518.5v5.6H38.7zM108.8 43.3h.2l20.6 78-19.2 2.6-6.6-37.1h-.2l-20.2 37.1H83L64.7 87h-.2l-6.6 36.9-19.6-2.6 21-78h.2l24.3 47.1 25-47.1zM174.4 74.4l10.2 19H164l10.4-19zm0-31.1l-41.1 76.8 18.6 4 7.8-16.6h29.1l8 16.6 19.4-4-41.8-76.8zM241.9 43.3v78.2l-19 1.8v-78l19-2zM299.5 65.5c-4.4-3.8-7.8-6-13.8-6-3.4 0-8.4 2-8.4 6 0 12.4 34.3 4.2 34.3 32.5 0 17.4-13.4 25.7-29.3 25.7-9.4 0-19.4-2.8-26.7-9l11.4-14.6c3.6 4.2 8.8 6.2 14.4 6.2 4 0 10-2 10-7 0-12-34.3-4.8-34.3-32.5 0-15.2 14.2-23.7 27.9-23.7 9 0 17.8 3.2 24.5 9l-10 13.4zM363.6 60.7c12.2 0 22 11 22 22.9s-9.8 22.9-22 22.9-22-11-22-22.9c-.2-11.8 9.8-22.9 22-22.9zm0-17.4c-22.4 0-41.1 17.8-41.1 40.3s18.6 40.3 41.1 40.3c22.6 0 41.1-17.8 41.1-40.3-.2-22.3-18.8-40.3-41.1-40.3zM486.9 123.9L436.6 80v41.3l-19 1.8V43.3h.2l50.3 43.1V45.1l19-1.8v80.6h-.2zM544.6 65.5c-4.4-3.8-7.8-6-13.8-6-3.4 0-8.4 2-8.4 6 0 12.4 34.3 4.2 34.3 32.5 0 17.4-13.4 25.7-29.3 25.7-9.4 0-19.4-2.8-26.7-9l11.4-14.6c3.6 4.2 8.8 6.2 14.4 6.2 4 0 10-2 10-7 0-12-34.3-4.8-34.3-32.5 0-15.2 14.2-23.7 27.9-23.7 9 0 17.8 3.2 24.5 9l-10 13.4zM48.1 170.2h3c6.2 0 11.2 5.4 11.2 11.4s-5 11.4-11.2 11.4h-3v-22.8zM38.5 201h13.6c11.2 0 20-8.4 20-19.6 0-11-9-19.6-20-19.6H38.5V201zM141.7 187.6c0 9-7 14.4-17 14.4-9 0-15.4-4.2-15.4-13.8v-26.3l9.6-.8v24.3c0 4.2 1.2 7.6 6 7.6 6.2 0 7-4.4 7-9.8v-21.4l9.6-.8.2 26.6zM261.8 161l10.4 39.5-9.8 1.4-3.4-18.8h-.2L248.4 202h-.2l-9.4-18.8h-.2l-3.4 18.8-9.8-1.4 10.8-39.5h.2l12.4 23.7 13-23.8zM326.5 170c6.2 0 11.2 5.6 11.2 11.6s-5 11.6-11.2 11.6c-6.2 0-11.2-5.6-11.2-11.6s5.2-11.6 11.2-11.6zm0-9c-11.4 0-21 9-21 20.6 0 11.4 9.4 20.6 21 20.6s21-9 21-20.6c-.1-11.6-9.4-20.6-21-20.6zM420.1 202l-25.5-22.4v21l-9.6.8v-40.5h.2l25.5 22v-21l9.6-.8-.2 40.9zM469.2 170.2h3c6.2 0 11.2 5.4 11.2 11.4s-5 11.4-11.2 11.4h-3v-22.8zm-9.6 30.8h13.6c11.2 0 20-8.4 20-19.6 0-11-9-19.6-20-19.6h-13.6V201zM530.8 201v-39h22l1.6 8.2h-14.2v6.8h10v8.2h-10v7.4h15.2l-2.4 8.2-22.2.2z"
    }
  })])])])]), _vm._v(" "), _c('ul', {
    staticClass: "col-5 h-100 m-0 p-0 d-flex list-unstyled justify-content-end align-items-center"
  }, [_c('li', {
    staticClass: "h-100 px-2 layer-container"
  }, [_c('IconTextLink', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.faqOpen,
      expression: "faqOpen"
    }],
    ref: "faqLink",
    staticClass: "icon-text-link h-100 layer-link",
    attrs: {
      "is-scramble-link": _vm.isScrambleLink,
      "icon": "infobulle",
      "label": _vm.$t('help'),
      "url": _vm.helpUrl,
      "target": '_blank',
      "theme": "dark",
      "aria-haspopup": "true"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.faqClick($event);
      }
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "h-100 px-2"
  }, [_c('IconTextLink', {
    staticClass: "icon-text-link h-100",
    attrs: {
      "url": _vm.storeLocUrl,
      "icon": "geoloc",
      "label": _vm.$t('store'),
      "data-el": "header__storelocator",
      "description": _vm.$t('store-description'),
      "theme": "dark",
      "is-prevent-default-link": "",
      "is-scramble-link": _vm.isScrambleLink
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.navigate($event, {
          event_action: 'Magasins'
        }, _vm.storeLocUrl);
      }
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "h-100 px-2 layer-container"
  }, [_vm.isMounted ? _c('IconTextLink', {
    ref: "accountLink",
    staticClass: "icon-text-link h-100 layer-link",
    attrs: {
      "is-scramble-link": _vm.isScrambleLink,
      "is-prevent-default-link": "",
      "data-el": "header__mini-customer",
      "icon": _vm.accountIcon,
      "label": _vm.$t('account'),
      "description": _vm.accountDescription,
      "url": _vm.accountUrl,
      "theme": "dark",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    nativeOn: {
      "mouseover": function mouseover($event) {
        _vm.accountHover = true;
      },
      "mouseleave": function mouseleave($event) {
        _vm.accountHover = false;
      },
      "focus": function focus($event) {
        return _vm.open(_vm.$refs.accountLink.$el);
      },
      "click": function click($event) {
        return _vm.navigate($event, {
          event_action: 'Mon compte'
        }, _vm.accountUrl);
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('AccountLayer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.user,
      expression: "user"
    }],
    ref: "accountLayer",
    staticClass: "layer-account layer-block px-0",
    attrs: {
      "is-scramble-link": _vm.isScrambleLink
    },
    on: {
      "close": function close($event) {
        return _vm.close(_vm.$refs.accountLink.$el);
      }
    }
  })], 1), _vm._v(" "), _vm.isMarketOpen ? _c('li', {
    staticClass: "basket-item h-100 px-2"
  }, [_c('MdmLink', {
    staticClass: "basket-link h-100 px-2 d-flex align-items-center",
    attrs: {
      "url": _vm.cartUrl,
      "is-scramble-link": _vm.isScrambleLink,
      "is-prevent-default-link": "",
      "rel": "nofollow",
      "data-el": "header__mini-cart"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.navigate($event, {
          event_action: 'Panier'
        }, _vm.cartUrl);
      }
    }
  }, [_c('i', {
    staticClass: "basket position-relative d-block"
  }, [_c('mdm-icon', {
    staticClass: "basket-icon",
    attrs: {
      "name": "bag",
      "alt": ""
    }
  }), _vm._v(" "), _vm.cart ? _c('span', {
    staticClass: "basket-counter d-inline-block position-absolute bg-white text-center font-weight-bold",
    attrs: {
      "data-el": "mini-header-entry__badge"
    },
    domProps: {
      "textContent": _vm._s(_vm.cart)
    }
  }) : _vm._e()], 1)])], 1) : _vm._e()])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };